exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".sz-30px{width:30px;height:30px}@media only screen and (min-width:992px){.btn--join-user-club{transform:translateX(-3rem)}}@media only screen and (max-width:768px){.btn--join-user-club{width:100%}}@media only screen and (min-width:992px){.pl-lg-6{padding-left:5.5rem}}.bg-primary-blue{background-color:#042d58}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["./~/bootstrap/scss/_functions.scss","./~/bootstrap/scss/_variables.scss","./src/main/webapp/content/scss/variables.scss"]}!./src/main/webapp/app/user-club/user-club.component.scss
// module id = 753
// module chunks = 0